export default "__VITE_ASSET__Bu2Tx3rb__"